var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOffer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 46.888 8.339 l 8.179 -3.998 c 2.084 -1.019 4.6 -0.201 5.687 1.848 l 4.267 8.042 c 0.622 1.172 1.749 1.991 3.055 2.22 l 8.967 1.573 c 2.284 0.401 3.839 2.541 3.515 4.837 l -1.275 9.014 c -0.186 1.313 0.245 2.639 1.167 3.592 l 6.33 6.543 c 1.613 1.667 1.613 4.312 0 5.979 l -6.33 6.543 c -0.922 0.953 -1.353 2.279 -1.167 3.592 l 1.275 9.014 c 0.325 2.296 -1.23 4.437 -3.515 4.837 l -8.967 1.573 c -1.306 0.229 -2.434 1.048 -3.055 2.22 l -4.267 8.042 c -1.087 2.049 -3.603 2.866 -5.687 1.848 l -8.179 -3.998 c -1.192 -0.582 -2.585 -0.582 -3.777 0 l -8.179 3.998 c -2.084 1.019 -4.6 0.201 -5.687 -1.848 l -4.267 -8.042 c -0.622 -1.172 -1.749 -1.991 -3.055 -2.22 l -8.967 -1.573 c -2.284 -0.401 -3.839 -2.541 -3.515 -4.837 l 1.275 -9.014 c 0.186 -1.313 -0.245 -2.639 -1.167 -3.592 l -6.33 -6.543 c -1.613 -1.667 -1.613 -4.312 0 -5.979 l 6.33 -6.543 c 0.922 -0.953 1.353 -2.279 1.167 -3.592 l -1.275 -9.014 c -0.325 -2.296 1.23 -4.437 3.515 -4.837 l 8.967 -1.573 c 1.306 -0.229 2.434 -1.048 3.055 -2.22 l 4.267 -8.042 c 1.087 -2.049 3.603 -2.866 5.687 -1.848 l 8.179 3.998 C 44.303 8.921 45.697 8.921 46.888 8.339 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,193,39)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 33.811 43.004 c -4.8 0 -8.705 -3.905 -8.705 -8.705 c 0 -4.8 3.905 -8.705 8.705 -8.705 s 8.705 3.905 8.705 8.705 C 42.516 39.1 38.611 43.004 33.811 43.004 z M 33.811 29.594 c -2.595 0 -4.706 2.111 -4.706 4.705 c 0 2.595 2.111 4.706 4.706 4.706 s 4.706 -2.111 4.706 -4.706 C 38.517 31.705 36.406 29.594 33.811 29.594 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 29.059 64.406 c -0.482 0 -0.966 -0.174 -1.35 -0.525 c -0.815 -0.746 -0.87 -2.01 -0.124 -2.825 l 31.881 -34.812 c 0.746 -0.814 2.01 -0.871 2.825 -0.124 c 0.814 0.746 0.87 2.011 0.124 2.825 l -31.88 34.812 C 30.14 64.187 29.601 64.406 29.059 64.406 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 57.166 64.406 c -4.8 0 -8.705 -3.905 -8.705 -8.705 s 3.905 -8.705 8.705 -8.705 s 8.705 3.905 8.705 8.705 S 61.966 64.406 57.166 64.406 z M 57.166 50.995 c -2.595 0 -4.706 2.111 -4.706 4.706 c 0 2.595 2.111 4.706 4.706 4.706 c 2.595 0 4.706 -2.111 4.706 -4.706 C 61.872 53.106 59.761 50.995 57.166 50.995 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 56.971 88.104 c -0.933 0 -1.882 -0.209 -2.781 -0.648 l -8.18 -3.998 c -0.643 -0.314 -1.38 -0.314 -2.02 0 l -8.18 3.998 c -3.069 1.504 -6.728 0.312 -8.331 -2.706 l -4.267 -8.043 c -0.335 -0.632 -0.93 -1.064 -1.634 -1.187 l -8.968 -1.573 c -3.366 -0.591 -5.627 -3.704 -5.149 -7.087 l 1.275 -9.015 c 0.099 -0.697 -0.134 -1.416 -0.623 -1.921 L 1.782 49.38 c -2.377 -2.455 -2.377 -6.304 0 -8.76 l 6.33 -6.543 c 0.497 -0.514 0.724 -1.214 0.624 -1.921 l -1.275 -9.015 c -0.478 -3.383 1.784 -6.497 5.149 -7.087 l 8.967 -1.573 c 0.704 -0.124 1.3 -0.557 1.635 -1.188 l 4.267 -8.043 c 1.601 -3.019 5.261 -4.209 8.331 -2.707 l 8.179 3.998 c 0.641 0.313 1.378 0.313 2.021 0 l 8.18 -3.998 c 3.069 -1.502 6.729 -0.312 8.33 2.707 l 4.268 8.042 c 0.335 0.632 0.93 1.064 1.634 1.188 l 8.968 1.573 c 3.365 0.591 5.627 3.704 5.148 7.087 l -1.275 9.015 c -0.101 0.707 0.128 1.408 0.625 1.921 l 6.33 6.543 c 2.376 2.456 2.376 6.304 0 8.76 l -6.33 6.543 c -0.497 0.514 -0.725 1.214 -0.625 1.922 l 1.275 9.014 c 0.478 3.383 -1.783 6.496 -5.148 7.087 l -8.968 1.573 c -0.705 0.123 -1.3 0.556 -1.633 1.186 L 62.52 84.75 C 61.388 86.884 59.225 88.103 56.971 88.104 z M 45 79.221 c 0.944 0 1.887 0.215 2.767 0.644 l 8.179 3.998 c 1.119 0.547 2.456 0.114 3.042 -0.988 l 4.268 -8.043 c 0.916 -1.729 2.548 -2.914 4.477 -3.251 l 8.967 -1.573 c 1.229 -0.216 2.054 -1.353 1.879 -2.588 l -1.275 -9.015 c -0.273 -1.939 0.35 -3.858 1.712 -5.263 l 6.329 -6.542 c 0.868 -0.897 0.868 -2.302 0 -3.198 l -6.33 -6.543 c -1.361 -1.406 -1.984 -3.324 -1.711 -5.262 l 1.275 -9.015 c 0.175 -1.236 -0.65 -2.372 -1.879 -2.588 l -8.968 -1.573 c -1.928 -0.338 -3.56 -1.524 -4.477 -3.253 l -4.267 -8.041 c -0.586 -1.103 -1.919 -1.537 -3.041 -0.989 l -8.181 3.998 l 0 0 c -1.757 0.859 -3.774 0.859 -5.532 0 l -8.179 -3.998 c -1.119 -0.548 -2.456 -0.113 -3.042 0.989 l -4.267 8.042 c -0.917 1.728 -2.548 2.914 -4.476 3.252 l -8.968 1.573 c -1.229 0.216 -2.055 1.353 -1.88 2.588 l 1.275 9.014 c 0.274 1.938 -0.349 3.856 -1.71 5.262 l -6.33 6.543 c -0.868 0.897 -0.868 2.302 0 3.198 l 6.331 6.543 c 1.361 1.406 1.984 3.324 1.71 5.262 l -1.275 9.015 c -0.175 1.235 0.651 2.373 1.881 2.588 l 8.967 1.573 c 1.927 0.337 3.559 1.522 4.477 3.251 l 4.267 8.043 c 0.584 1.101 1.919 1.534 3.043 0.988 l 8.179 -3.998 C 43.112 79.435 44.056 79.221 45 79.221 z M 46.888 8.339 h 0.01 H 46.888 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffer);
export default __webpack_public_path__ + "static/media/offer.7fef94a41074597ea4532ca72e460376.svg";
export { ForwardRef as ReactComponent };